// @ts-strict-ignore
export const limitMonacoCharacterLength = ({ editor, maxLength }) => {
  if (editor) {
    editor.onDidChangeModelContent(() => {
      const model = editor.getModel();
      if (!model) {
        return;
      }
      const curValue = model.getValue() || "";
      if (curValue.length > maxLength) {
        const position = editor.getPosition();
        if (!position) {
          return;
        }
        const trimmedValue = curValue.substring(0, maxLength);
        const cursorOffset = model.getOffsetAt(position);
        editor.executeEdits("character-limiter", [
          {
            range: model.getFullModelRange(),
            text: trimmedValue,
          },
        ]);
        const safeOffset = Math.min(cursorOffset, model.getValueLength());
        editor.setPosition(model.getPositionAt(safeOffset));
      }
    });
  }
};
